import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Cookies from "vue-cookies";
import VuePapaParse from "vue-papa-parse";
// eslint-disable-next-line
import styles from "./styles/source_sans_pro.css";

Vue.config.productionTip = false;

Vue.use(Cookies);
Vue.use(VuePapaParse);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
